module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_02_770_280_ja-1d6f854ef46339aa67b061257e39d5c6.jpg";